/**
 * 徕卡学院
 * 
 */
import addCurriculum from '@/components/lkcollege/addCurriculum' //添加课程
import listCurriculum from '@/components/lkcollege/listCurriculum'//课程列表
import details from '@/components/lkcollege/details'//课程详情
import queryCurriculum from '@/components/lkcollege/queryCurriculum'//课程高查询
import lookProduction from '@/components/lkcollege/lookProduction'//查看作品
import calendarCurriculum from '@/components/lkcollege/calendarCurriculum'//日历
export default [
  {
    path: '/addCurriculum',
    name: 'addCurriculum',
    component: addCurriculum,
    meta: {
      title: "添加课程"
    }
  },
  {
    path: '/listCurriculum',
    name: 'listCurriculum',
    component: listCurriculum,
    meta: {
      title: "课程列表",
      keepAlive:false
    }
  },
  {
    path: '/detailsCurriculum',
    name: 'detailsCurriculum',
    component: details,
    meta: {
      title: "课程详情"
    }
  },
  {
    path: '/queryCurriculum',
    name: 'queryCurriculum',
    component: queryCurriculum,
    meta: {
      title: "课程高级查询",
      keepAlive:false
    }
  },
  {
    path: '/lookProduction',
    name: 'lookProduction',
    component: lookProduction,
    meta: {
      title: "查看作品"
    }
  },
  {
    path: '/calendarCurriculum',
    name: 'calendarCurriculum',
    component: calendarCurriculum,
    meta: {
      title: "日历"
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/curriculum.js